<template>
  <div class="bg-container page">
    <img class="bg-img" src="/img/login/login.png">
    <div class="bg-wrapper">
      <div class="register">
        <van-nav-bar class="nav-bar">
          <template #left>
            <van-icon name="arrow-left" color="#fff" @click="back()" />
          </template>
        </van-nav-bar>

        <div class="wrapper">
          <div class="title">{{ $t("auth.register") }}</div>

          <div class="loginForm">
            <van-field
              v-model="username"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.username_place')"
            />

            <van-field
              v-model="email"
              clearable
              input-align="center"
              class="input"
              placeholder="メールアドレスを入力してください（任意）"
            />

            <van-field
              v-model="password"
              :type="passwordType"
              input-align="center"
              class="input"
              :placeholder="$t('auth.pwd_place')"
            >
              <template slot="right-icon">
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
                />
              </template>
            </van-field>

            <van-field
              v-model="code"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.invite_code_place')"
            />

            <div class="agreement">
              <van-checkbox v-model="checked" />
              <span class="agreement-text">
                <a href="https://pairsvip.com/pairs/terms" class="terms-link">利用規約</a>
                に同意します
              </span>
            </div>

            <van-button
              class="login-btn"
              type="primary"
              size="normal"
              :disabled="submitting"
              @click="doRegister()"
            >
              {{ $t("auth.register") }}
            </van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },

  props: {
    inputValue: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      checked: true,
      username: '',
      email: '',
      code: '',
      lang: 'en_us',
      password: this.inputValue,
      passwordType: 'password',
      submitting: false
    };
  },

  mounted() {
    this.lang = localStorage.getItem("lang") || 'es_spa';
  },

  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },

    back() {
      return window.history.back();
    },

    doRegister() {
      if (this.submitting) {
        return false;
      }

      if (!this.username) {
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }

      // 邮箱为可选项；填写时才校验格式。
      const emailReg = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/;
      if (this.email && !emailReg.test(this.email)) {
        this.$toast.fail("メールアドレスの形式が正しくありません");
        return false;
      }

      if (!this.password) {
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }

      if (!this.code) {
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }

      if (!this.checked) {
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }

      this.submitting = true;

      this.$http({
        method: 'post',
        data: {
          username: this.username,
          email: this.email,
          password: this.password,
          code: this.code,
          lang: this.lang
        },
        url: 'member_register'
      }).then(res => {
        this.submitting = false;
        const result = res && res.data && typeof res.data === 'object' ? res.data : res;
        const code = result && result.code !== undefined ? Number(result.code) : -1;
        const msg = (result && result.msg) ? result.msg : 'error';

        if (code === 200) {
          this.$toast.success(msg);
          localStorage.setItem('token', result.data);
          this.$router.push("Mine");
        } else {
          this.$toast.fail(msg);
        }
      }).catch(err => {
        this.submitting = false;
        console.error('member_register error:', err);
        this.$toast.fail('network error');
      });
    }
  },

  created() {
    if (localStorage.getItem('token')) {
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.register { height: 100%; }
.bg-container .bg-wrapper .register .nav-bar { background: 0 0; }
.register .wrapper { overflow-y: auto; -webkit-overflow-scrolling: touch; }
.register .wrapper .title { line-height: 100px; text-align: center; font-size: 45px; font-weight: 700; color: #fff; letter-spacing: 5px; }
.register .wrapper .loginForm { padding: 60px; }
.register .wrapper .loginForm .input { padding: 10px 20px; margin-top: 35px; border-radius: 50px; text-align: center; line-height: 70px; font-size: 30px; color: #4e4e4e; }
::v-deep .van-field__right-icon .van-icon { font-size: 50px; }
::v-deep .van-icon { font-size: 50px; }
.register .wrapper .loginForm .login-btn { margin-top: 30px; width: 100%; height: 100px; border-radius: 50px; color: #fff; background: linear-gradient(90deg, #6529c9, #cc2996); font-size: 30px; font-weight: bolder; border: none; }
.register .wrapper .loginForm .agreement { margin-top: 30px; display: flex; align-items: center; justify-content: center; }
.register .wrapper .loginForm .agreement .agreement-text { margin-left: 10px; font-size: 25px; color: #fff; font-weight: 500; line-height: 30px; }
.terms-link { color: #fff; text-decoration: underline; font-weight: bold; }
::v-deep .agreement .van-icon { font-size: 30px; }
::v-deep .agreement .van-checkbox__icon { font-size: 38px; }
::v-deep .agreement .van-checkbox__icon--checked .van-icon { color: #fff; border-color: rgb(126, 86, 120); background-color: rgb(126, 86, 120); }
</style>
